import { PageLayout } from 'common/components';
import queryString from 'query-string';
import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { InternalTransfer } from '../_components';

const CommonInternalTransferPage = () => {
  const location = useLocation();
  const { account } = useMemo(() => queryString.parse(location.search), [location.search]);

  return (
    <PageLayout captionSlug="clientInternalTransfer" showReload={false}>
      <InternalTransfer account={+account} />
    </PageLayout>
  );
};

export default CommonInternalTransferPage;
